import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import AlertListUI from '../../components/finapp/alert/AlertListUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import DueDateUpdateModalSF from '../../components/finapp/alert/DueDateUpdateModalSF'
import SendReminderModalSF from '../../components/finapp/alert/SendReminderModalSF'
import BudgetFundRequestModalSF from '../../components/finapp/alert/BudgetFundRequestModalSF'
import './AlertListPage.css'

const AlertListPageUI = ({ context, messageList, errorList, alertList, filteredAlertList,
  // change due date
  onUpdateDueDateClick, updateDueDateMode, onCancelUpdateDueDate, onUpdateDueDateComplete,
  // send reminder
  onSendReminderClick, sendReminderMode, onCancelSendReminder, onSendReminderComplete,
  // allocate funds
  onAllocateClick, allocateMode, onCancelAllocate, onAllocateComplete,
  searchFilter, onRefreshClick, onDismissClick, onSearchFilterChange
}) =>
  <PrivatePageSF context={context} className='pg_alerts'
    messageList={messageList} headerMessageKey='c_alerts'
    centered={(!alertList && !errorList) || (alertList && alertList.length === 0)}
  >
    {
      !alertList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      alertList &&
      <React.Fragment>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_alerts'
        />
      </React.Fragment>
    }
    {
      alertList && alertList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={false}
        createDisabledMessageKey='c_no_alert_msg'
      />
    }
    {
      alertList && filteredAlertList && alertList.length !== 0 &&
      <AlertListUI
        context={context}
        alertList={filteredAlertList}
        messageList={messageList}
        searchFilter={searchFilter}
        // events
        onRefreshClick={onRefreshClick}
        onDismissClick={onDismissClick}
        onSearchFilterChange={onSearchFilterChange}
        onUpdateDueDateClick={onUpdateDueDateClick}
        onSendReminderClick={onSendReminderClick}
        onAllocateClick={onAllocateClick}

      />
    }
    <DueDateUpdateModalSF context={context} updateMode={updateDueDateMode}
      onCancelClick={onCancelUpdateDueDate} onUpdateComplete={onUpdateDueDateComplete}
    />
    <SendReminderModalSF context={context} sendMode={sendReminderMode}
      onCancelClick={onCancelSendReminder} onSendComplete={onSendReminderComplete}
    />
    <BudgetFundRequestModalSF context={context} allocateMode={allocateMode}
      onCancelClick={onCancelAllocate} onAllocateComplete={onAllocateComplete}
    />
  </PrivatePageSF>

export default AlertListPageUI
